import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Button as Button2,
  Column,
  ColumnChooser,
  Editing,
  FilterRow,
  Form,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Texts,
  Toolbar,
} from "devextreme-react/data-grid";
import {
  AsyncRule,
  EmailRule,
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
  StringLengthRule,
} from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../utils/hasPermission";
import { PERM } from "../../../utils/permissions";
import { notifyMsg } from "../../common/notify";
import { ny, resp, solarLunar, tenure } from "./data";

export default function EmployeeList(props) {
  const {
    employeeDataGridRef,
    setCurrentEmployee /*, divDataSource*/,
    setEmployeeInfoPopupVisible,
  } = props;

  const [dataSource, setDataSource] = useState(null);
  const [editRowKey, setEditRowKey] = useState(null);
  const [divDataSource, setDivDataSource] = useState(null);
  const [jdDataSource, setJdDataSource] = useState(null);

  // const [selectedEmployeeNo, setSelectedEmployeeNo] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);
  const canEditEmp = hasPermission(userInfo.permissions, PERM.ORG_EMP_EDIT);

  // const jdDataSource = new DataSource({
  //   store: {
  //     data: jd,
  //     type: "array",
  //     key: "id",
  //   },
  // });

  useEffect(async () => {
    setDataSource(
      new CustomStore({
        key: "employeeNo",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee?tenure=${
              !canEditEmp ? `1` : ``
            }&orderBy=[employeeNo]`
          );

          // setEmployeeList(result.data);

          return result.data;
        },
        insert: async (values) => {
          const result = await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee`,
            values
          );
          console.log("insert result", result);
          if (result.data?.profileCreated) {
            notifyMsg("기존에 없던 직책 조합입니다. 연결된 권한이 없으니 필요한 경우 권한을 새로 지정해 주세요.", "warning");
          }
        },

        update: async (key, values) => {
          const result = await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/${key}`,
            values
          );
          console.log("update result", result);
          if (result.data?.profileCreated) {
            notifyMsg("기존에 없던 직책 조합입니다. 연결된 권한이 없으니 필요한 경우 권한을 새로 지정해 주세요.", "warning");
          }

          setEditRowKey(null);
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/employee/${key}`
          );
        },
        errorHandler: (error) => {
          error.message =
            "해당 Employee의 담당 프로젝트가 있습니다. Employee 삭제가 불가능합니다.";
        },
      })
    );

    // setDivDataSource(
    //   new CustomStore({
    //     key: "div",
    //     load: async () => {
    //       const result = await axios.get(
    //         `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div?includeBCC=false`
    //       );

    //       console.debug("div", result.data);

    //       return result.data;
    //     },
    //   })
    // );

    // axios
    //   .get(
    //     `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div?includeBCC=false`
    //   )
    //   .then((result) => {
    //     setDivDataSource(result.data);
    //   });

    // const jdDataSource = new DataSource({
    //   store: {
    //     data: jd,
    //     type: "array",
    //     key: "id",
    //   },
    // });

    axios
      .get(`${process.env.REACT_APP_BECCO_API_URL}/api/employee/jd`)
      .then((result) => {
        setJdDataSource(
          new DataSource({
            store: {
              data: result.data,
              type: "array",
              key: "jd",
            },
          })
        );
      });
  }, []);

  const onSelectionChanged = ({ selectedRowsData }) => {
    setCurrentEmployee(selectedRowsData[0]);
  };

  const calculateCellValue = (data) => {
    if (data.dob) {
      const date = new Date(data.dob);

      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(date.getDate()).padStart(2, "0")} (${
        data.solarLunar == 1 ? `양력` : `음력`
      })`;
    } else {
      return null;
    }
  };

  const calculateDisplayValue = (data) => {
    if (data.mob) {
      return `010-${data.mob.substring(0, 4)}-${data.mob.substring(4)}`;
    } else {
      return null;
    }
  };

  const validationCallback = async (params) => {
    // if (!params.data.employeeNo || params.data.employeeNo != params.value) {
    if (!editRowKey || editRowKey != params.value) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/hasEmployee/${params.value}`
      );

      return result.data.nEmployeeNo == 0;
    } else {
      return true;
    }
    // } else {
    // return true;
    // }
  };

  const validationCallbackEmail = async (params) => {
    // if (!params.data.email || params.data.email != params.value) {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee/hasEmployee/${editRowKey}?email=${params.value}`
    );

    return result.data.nEmployeeNo == 0;
    // } else {
    // return true;
    // }
  };

  const onInitNewRow = (e) => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div?includeBCC=false`
      )
      .then((result) => {
        setDivDataSource(result.data);
      });
  };

  const onEditingStart = (e) => {
    setEditRowKey(e.key);

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div?includeBCC=false`
      )
      .then((result) => {
        setDivDataSource(result.data);
      });
  };

  const onEditCanceled = (e) => {
    setEditRowKey(null);
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;
      return;
    }

    const newJd = {
      name: args.text,
      jd: args.text,
    };

    args.customItem = jdDataSource
      .store()
      .insert(newJd)
      .then(() => jdDataSource.load())
      .then(() => newJd)
      .catch((error) => {
        throw error;
      });
  };

  // const onCellPrepared = (e) => {
  //   console.debug("[onCellPrepared]");
  //   console.debug("e.rowType", e.rowType);

  //   if (e.rowType == "header") {
  //     e.cellElement.classList.add("header");

  //     console.debug("e.cellElement", e.cellElement);
  //   }
  // };

  const onClick = (e) => {
    employeeDataGridRef.current.instance.selectRows(
      [e.row.data.employeeNo],
      false
    );

    setCurrentEmployee(e.row.data);
    setEmployeeInfoPopupVisible(true);
    // if (
    //   employeeDataGridRef.current.instance.option("selectedRowKeys").length > 0
    // ) {
    //   setEmployeeInfoPopupVisible(true);

    //   // setSelectedEmployeeNo(
    //   //   employeeDataGridRef.current.instance.option("selectedRowKeys")[0]
    //   // );
    // } else {
    //   notifyMsg("Employee를 선택해주세요", "warning");
    // }
  };

  return (
    <React.Fragment>
      <DataGrid
        ref={employeeDataGridRef}
        keyExpr={"employeeNo"}
        dataSource={dataSource}
        hoverStateEnabled={true}
        width="100%"
        height="100%"
        // height={500}
        showBorders={true}
        showColumnHeaders={true}
        showColumnLines={true}
        style={{
          maxHeight: "calc(100vh - 180px)",
        }}
        // autoNavigateToFocusedRow={true}
        // focusedRowEnabled={true}
        onSelectionChanged={onSelectionChanged}
        // onRowValidating={onRowValidating}
        // onContentReady={onContentReady}
        onEditingStart={onEditingStart}
        onEditCanceled={onEditCanceled}
        onInitNewRow={onInitNewRow}
        // onCellPrepared={onCellPrepared}
      >
        <LoadPanel enabled={true} />

        <Scrolling mode={"virtual"} showScrollbar="always" />

        <Selection mode={"single"} />

        <ColumnChooser enabled={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <SearchPanel visible={true} />

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"Organization.EmployeeList"}
        />

        {canEditEmp && (
          <Editing
            mode={"popup"}
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
          >
            <Texts
              confirmDeleteTitle={"Delete the Employee"}
              confirmDeleteMessage={
                "Are you sure you want to delete this employee?"
              }
            />
            <Popup
              // title={"Employee Info."}
              title={"EMPLOYEE INFO."}
              showTitle={true}
              // width="1200"
              height={"auto"}
              // hideOnOutsideClick={true}
              // dragEnabled={false}
              // showCloseButton={true}
            />
            <Form
              labelMode="outside"
              showColonAfterLabel={false}
              labelLocation={"top"}
              minColWidth={300}
              colCount={2}
              colCountByScreen={{ sm: 2, md: 4 }}
              screenByWidth={(width) => {
                return width < 720 ? "sm" : "md";
              }}
              validationGroup="employee"
              height={"100%"}
            >
              <SimpleItem
                dataField={"employeeNo"}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <Label text={"Employee No."} />
                <RequiredRule message={"* Employee No.를 입력해주세요."} />
                <StringLengthRule
                  min={8}
                  max={8}
                  message="Character Length of Employee No. is 8."
                />

                <AsyncRule
                  message={"Employee No. is alreay registered."}
                  validationCallback={validationCallback}
                  // reevaluate={false}
                />
              </SimpleItem>
              <SimpleItem
                dataField={"name"}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <Label text={"Name"} />
                <RequiredRule message={"* Name을 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"enName"}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                }}
              >
                <Label text={"English Name"} />
                <RequiredRule message={"* English name을 입력해주세요."} />
              </SimpleItem>
              <EmptyItem />
              <SimpleItem
                dataField={"tenure"}
                editorOptions={{ showClearButton: true }}
              >
                <RequiredRule message={"* Tenure를 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"startDate"}
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  displayFormat: "yyyy-MM-dd",
                  dateSerializationFormat: "yyyy-MM-dd",
                  showClearButton: true,
                  min: new Date("2022-04-01"),
                }}
              >
                <Label text={"Start Date"} />
                <RequiredRule message={"* Start date를 입력해주세요."} />
                {/* <CustomRule
                  message={"Employee No.와 Start Date가 상이합니다."}
                  validationCallback={validationCallbackStartDate}
                /> */}
              </SimpleItem>
              <EmptyItem />
              <EmptyItem />
              <SimpleItem
                dataField={"div"}
                editorType="dxSelectBox"
                editorOptions={{
                  showClearButton: true,
                  dataSource: divDataSource,
                  displayExpr: "name",
                  valueExpr: "div",
                }}
              >
                <RequiredRule message={"* Division을 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"jd"}
                editorType="dxSelectBox"
                editorOptions={{
                  showClearButton: true,
                  dataSource: jdDataSource,
                  displayExpr: "name",
                  // displayExpr: "id",
                  valueExpr: "jd",
                  acceptCustomValue: true,
                  onCustomItemCreating: onCustomItemCreating,
                }}
              >
                <RequiredRule message={"* Job Description을 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"resp"}
                editorOptions={{ showClearButton: true }}
              />
              <SimpleItem
                dataField={"canBeAMgr"}
                editorOptions={{ showClearButton: true }}
              />
              <SimpleItem
                dataField={"mob"}
                editorType="dxTextBox"
                editorOptions={{
                  showClearButton: true,
                  mask: "\\01\\0-0000-0000",
                }}
              >
                <RequiredRule message={"* Mobile를 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"email"}
                editorOptions={{ showClearButton: true }}
              >
                <RequiredRule message={"* Email을 입력해주세요."} />
                <EmailRule message={"Email is invalid."} />
                <AsyncRule
                  message={"Email is already registered."}
                  validationCallback={validationCallbackEmail}
                />
              </SimpleItem>
              <SimpleItem
                dataField={"dob"}
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  displayFormat: "yyyy-MM-dd",
                  dateSerializationFormat: "yyyy-MM-dd",
                  showClearButton: true,
                }}
              >
                <Label text={"Birth Date"} />
                <RequiredRule message={"* Birth date를 입력해주세요."} />
              </SimpleItem>
              <SimpleItem
                dataField={"solarLunar"}
                editorOptions={{ showClearButton: true }}
              >
                <Label text={"Solar/Lunar"} />
                <RequiredRule message={"* Solar/Lunar를 입력해주세요."} />
              </SimpleItem>
            </Form>
          </Editing>
        )}

        <Column
          dataField={"employeeNo"}
          caption="Employee No."
          width={140}
          alignment="center"
        >
          {/* <AsyncRule
            message={"Employee No. is alreay registered."}
            validationCallback={validationCallback}
            reevaluate={false}
          /> */}
          {/* <RequiredRule2 message={"* Employee No.를 입력해주세요."} /> */}
        </Column>
        <Column
          dataField={"name"}
          caption="Name"
          width={100}
          alignment="center"
        />
        <Column
          dataField={"enName"}
          caption="English Name"
          width={150}
          alignment="center"
        />
        <Column
          dataField={"startDate"}
          caption="Start Date"
          dataType={"date"}
          format="yyyy-MM-dd"
          editorOptions={{ dateSerializationFormat: "yyyy-MM-dd" }}
          width={120}
          alignment="center"
        />
        <Column
          dataField={"tenure"}
          caption="Tenure"
          width={100}
          alignment="center"
        >
          <Lookup dataSource={tenure} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column
          dataField={"div"}
          caption="Division"
          width={250}
          alignment="center"
        >
          {/* <Lookup
            dataSource={divDataSource}
            displayExpr="name"
            valueExpr={"div"}
          /> */}
        </Column>
        <Column
          dataField={"jd"}
          caption="Job Description"
          width={190}
          alignment="center"
        >
          {/* <Lookup dataSource={jd} displayExpr="name" valueExpr={"id"} /> */}
        </Column>
        <Column
          dataField={"resp"}
          caption="Responsibiltiy"
          width={110}
          alignment="center"
          visible={false}
        >
          <Lookup dataSource={resp} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column
          dataField={"canBeAMgr"}
          caption="Can be a Manager"
          width={130}
          alignment="center"
          visible={false}
        >
          <Lookup dataSource={ny} displayExpr="name" valueExpr={"id"} />
        </Column>
        <Column
          dataField={"mob"}
          caption="Mobile"
          width={120}
          alignment="center"
          calculateDisplayValue={calculateDisplayValue}
        />
        <Column dataField={"email"} caption="Email" width={250}></Column>
        <Column
          dataField={"dob"}
          caption="Birth Date"
          dataType={"date"}
          format="yyyy-MM-dd"
          editorOptions={{ dateSerializationFormat: "yyyy-MM-dd" }}
          width={100}
          alignment="center"
          calculateCellValue={calculateCellValue}
          visible={false}
        />
        <Column dataField={"solarLunar"} caption="Solar/Lunar" visible={false}>
          <Lookup dataSource={solarLunar} displayExpr="name" valueExpr={"id"} />
        </Column>

        {userInfo.jd != "RV" && (
          <Column type={"buttons"} width={100}>
            {canEditEmp && <Button2 name={"edit"} />}
            {canEditEmp && <Button2 name={"delete"} />}
            <Button2
              icon="card"
              hint="Personal Record"
              visible={true}
              onClick={onClick}
            />
          </Column>
        )}

        <Toolbar>
          {/* <Item location={"before"}>
                <span
                  style={{
                    fontWeight: 500,
                    color: "#009688",
                    marginLeft: "10px",
                  }}
                >
                  EMPLOYEE LIST
                </span>
              </Item> */}
          <Item location={"after"} name="addRowButton"></Item>
          {/* {userInfo.jd != "RV" && (
            <Item location="after">
              <Button icon="card" onClick={onClick} />
            </Item>
          )} */}
          <Item location={"after"} name="columnChooserButton" />
          <Item location="after" name="searchPanel" />
        </Toolbar>
      </DataGrid>
      {/* {selectedEmployeeNo && (
        <Popup2
          id="employeeInfoPopup"
          visible={employeeInfoPopupVisible}
          dragEnabled={false}
          hideOnOutsideClick={false}
          showCloseButton={true}
          title="PERSONAL RECORD"
          width={1500}
          height={"auto"}
          onHiding={onHiding}
        >
          <BasicInformation userInfo={{ employeeNo: selectedEmployeeNo }} />
        </Popup2>
      )} */}
    </React.Fragment>
  );
}
